var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTeletherapy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "34px",
    viewBox: "0 0 56 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F3F22FA4-514E-4A34-ADC5-2EFCF9DCCE69") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_Dash+StartV4_S1",
    transform: "translate(-513.000000, -280.000000)",
    fill: "#F9F1FE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(391.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(91.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-teletherapy",
    transform: "translate(31.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7015794,31.2457978 L22.7015794,32.2012926 L33.3523404,32.2012926 L33.3523404,31.2457978 L56,31.2457978 L56,31.6387853 C56,32.2574337 55.7749146,32.876082 55.3269312,33.3252106 C54.8778541,33.7754357 54.261877,34 53.6448061,34 L53.6448061,34 L2.35519385,34 C1.738123,34 1.12105215,33.7743392 0.673068773,33.3252106 C0.223991688,32.8749855 0,32.2574337 0,31.6387853 L0,31.6387853 L0,31.2457978 L22.7015794,31.2457978 Z M7.51159625,32.538139 L5.15738674,32.538139 L5.15738674,32.8188444 L7.51159625,32.8188444 L7.51159625,32.538139 Z M49.3273882,0 C49.7193737,0 50.1124529,0.168423225 50.3924425,0.449128601 C50.6724321,0.729833976 50.8404258,1.12391801 50.8404258,1.51690553 L50.8404258,1.51690553 L50.8404258,28.8295386 C50.8404258,29.2225261 50.6724321,29.6166101 50.3924425,29.8973155 C50.1124529,30.1780209 49.7193737,30.3464441 49.3273882,30.3464441 L49.3273882,30.3464441 L6.67042434,30.3464441 C6.27843889,30.3464441 5.94135764,30.2341619 5.60537011,29.896219 C5.3253805,29.6155136 5.15738674,29.2214296 5.15738674,28.8284421 L5.15738674,28.8284421 L5.15738674,1.51690553 C5.15738674,1.12391801 5.3253805,0.729833976 5.60537011,0.449128601 C5.88535972,0.168423225 6.27843889,0 6.67042434,0 L6.67042434,0 Z M48.4875288,2.36011816 L7.56759417,2.36011816 L7.56759417,27.9862163 L48.4875288,27.9862163 L48.4875288,2.36011816 Z M28.0269599,0.674789406 C27.7469703,0.674789406 27.5229786,0.899353707 27.5229786,1.18005908 C27.5229786,1.46076446 27.7469703,1.68532876 28.0269599,1.68532876 C28.3069495,1.68532876 28.5309412,1.46076446 28.5309412,1.18005908 C28.5309412,0.899353707 28.3069495,0.674789406 28.0269599,0.674789406 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeletherapy);
export default __webpack_public_path__ + "static/media/icon-teletherapy.0f8e460c322c0d9f376168e8b4e267b4.svg";
export { ForwardRef as ReactComponent };